import { Modal } from '@mantine/core';
import { useRef } from 'react';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import RedButton from '../../components/Buttons/RedButton';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../redux/slices/userAuthSlice';
import { useSelector } from '../../redux/store';

type TimeoutPopupProps = {
    opened: boolean;
    close: () => void;
    focusKey: string;
};

const TimeoutPopup = ({ opened, close, focusKey: focusKeyParam }: TimeoutPopupProps) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector((state) => state.userAuth.user);

    const { ref, focusKey } = useFocusable({
        focusKey: focusKeyParam,
        isFocusBoundary: true,
        focusBoundaryDirections: ['down', 'up', 'right', 'left'],
        preferredChildFocusKey: 'STAY-BUTTON',
    });
    const modalContainerRef = useRef<HTMLDivElement>(null);

    const handleLogout = () => {
        //dispatch(logout());
        navigate('/');
        close();
    };

    return (
        <FocusContext.Provider value={focusKey}>
            <div ref={ref}>
                <Modal
                    opened={opened}
                    onClose={close}
                    centered={true}
                    size={`40vw`}
                    radius={`3vw`}
                    withCloseButton={false}
                    overlayProps={{
                        backgroundOpacity: 0.2,
                        blur: 12,
                    }}
                    styles={{
                        header: {
                            backgroundColor: 'black',
                            outline: 'none',
                        },
                        content: {
                            backgroundColor: 'transparent',
                        },
                    }}
                >
                    <div
                        className="bg-black flex flex-col items-center justify-evenly w-[100%] overflow-y-auto max-h-[45vh] p-[2vw] border-[0.1vw] border-white rounded-[1vw]"
                        ref={modalContainerRef}
                    >
                        <span className="text-[2vw] text-white mb-[2vw] max-w-[30vw] text-center">
                            {`היי ${user?.first_name || ''} ! אתה עדיין פה?`}
                        </span>
                        <RedButton
                            className="mt-[0.6vw] py-[0.8vh] outline-none bg-white bg-opacity-15 !text-[1.6vw] w-[16vw] rounded-[3vh] mb-[1.2vw]"
                            onFocusClass={`!bg-pizzahut-red !text-white !scale-110`}
                            focusKey={`STAY-BUTTON`}
                            onClick={close}
                        >
                            כן
                        </RedButton>
                        <RedButton
                            className="mt-[0.6vw] py-[0.8vh] outline-none bg-white bg-opacity-15 !text-[1.6vw] w-[16vw] rounded-[3vh]"
                            onFocusClass={`!bg-pizzahut-red !text-white !scale-110`}
                            focusKey={`LOGOUT-BUTTON`}
                            onClick={handleLogout}
                        >
                            חזרה לדף הבית
                        </RedButton>
                    </div>
                </Modal>
            </div>
        </FocusContext.Provider>
    );
};

export default TimeoutPopup;
